import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
type ExternLogoMonoProps = SVGProps<SVGSVGElement> & {
  color?: 'white' | 'black';
};
export function ExternLogoMono(props) {
  const $ = _c(12);
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      color: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = rest;
    $[2] = t0;
  } else {
    rest = $[1];
    t0 = $[2];
  }
  const color = t0 === undefined ? "black" : t0;
  const fillColor = color === "white" ? "#FFFFFF" : "#1C1B1B";
  let t1;
  let t2;
  let t3;
  if ($[3] !== fillColor) {
    t1 = <path d="M9.38535 21.8163C9.65285 21.3965 10.2661 21.3975 10.5322 21.8182L14.6262 28.2908C14.9123 28.7432 14.5873 29.3332 14.0521 29.3332H5.83382C5.29766 29.3332 4.97287 28.7411 5.26099 28.2889L9.38535 21.8163Z" fill={fillColor} />;
    t2 = <path d="M22.4629 10.2185C22.7304 10.6383 23.3437 10.6373 23.6098 10.2166L27.7037 3.74391C27.9898 3.29164 27.6649 2.70157 27.1297 2.70157H18.9114C18.3753 2.70157 18.0505 3.29365 18.3386 3.74583L22.4629 10.2185Z" fill={fillColor} />;
    t3 = <path d="M14.6586 6.72227C12.6231 3.29976 9.6176 2.6665 8.2487 2.6665C7.71241 2.6665 3.66415 2.67446 3.40055 2.67446C2.4288 2.67446 2.48637 3.71008 3.19914 3.97321C5.06299 4.66123 6.45534 6.31126 7.4939 7.95223C8.2487 9.14479 17.6248 24.2563 18.2913 25.2768C20.5164 28.6829 23.3324 29.3326 24.7012 29.3326C25.2376 29.3326 29.2858 29.3245 29.5494 29.3245C30.5211 29.3245 30.4636 28.2889 29.7508 28.0259C27.887 27.3378 26.5512 25.6492 25.4561 24.0469C24.7012 22.9424 18.3293 12.6556 14.6586 6.72227Z" fill={fillColor} />;
    $[3] = fillColor;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rest || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <svg aria-hidden="true" fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg" {...rest}>{t1}{t2}{t3}</svg>;
    $[7] = rest;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}